import React from 'react';
import './FEFooter.css';

const FEFooter = () => {
    const overlayBg = '/assets/custom/images/big-overlay.jpg';

    return (
        <>
            {/* Compliance / legal block */}
            <section
                className="fe-compliance"
                style={{ backgroundImage: `url(${overlayBg})` }}
            >
                <div className="fe-compliance__overlay">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-8 text-center">
                                <h2 className="fe-compliance__heading">
                                    Cumplimiento Normativo Garantizado
                                </h2>
                                <p className="fe-compliance__subheading">
                                    Emisor Electrónico certificado ante la DGII para la emisión de
                                    Comprobantes Fiscales Electrónicos (e-CF)
                                </p>
                                <p className="fe-compliance__body">
                                    La Ley 32-23 y el Decreto 254-06 establecen el marco legal para
                                    la facturación electrónica en República Dominicana. Los grandes y
                                    medianos contribuyentes ya están obligados a emitir e-CF, y el plazo
                                    final para micro, pequeñas empresas y contribuyentes no clasificados
                                    vence el 15 de noviembre de 2026. El incumplimiento conlleva
                                    sanciones de 5 a 30 salarios mínimos.
                                </p>
                                <p className="fe-compliance__body">
                                    Nuestro software cumple con todas las especificaciones técnicas
                                    de la DGII: firma digital con certificados autorizados por INDOTEL
                                    (según Ley 126-02 y Decreto 587-24), formato XML estandarizado,
                                    transmisión automática a la DGII y almacenamiento seguro por el
                                    período de 10 años requerido por ley.
                                </p>

                                <div className="fe-compliance__badges">
                                    <div className="fe-compliance__badge">
                                        <i className="fas fa-certificate fe-compliance__badge-icon"></i>
                                        {/* REVISAR CLAIM: no decir "Certificado DGII" a secas ni PSFE hasta la autorización oficial */}
                                        <span>Emisor Electrónico certificado ante la DGII</span>
                                    </div>
                                    <div className="fe-compliance__badge">
                                        <i className="fas fa-shield-alt fe-compliance__badge-icon"></i>
                                        <span>Firma Digital Integrada</span>
                                    </div>
                                    <div className="fe-compliance__badge">
                                        <i className="fas fa-server fe-compliance__badge-icon"></i>
                                        <span>Almacenamiento Seguro 10 años</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA block */}
            <section className="fe-cta-block">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8 text-center">
                            <h2 className="fe-cta-block__heading">
                                ¿Listo para simplificar tu facturación?
                            </h2>
                            <p className="fe-cta-block__subtext">
                                Certifícate antes del plazo obligatorio y accede al crédito fiscal
                                por adopción temprana. Contabilidad + facturación electrónica integrados.
                            </p>
                            <div className="fe-cta-block__actions">
                                <a
                                    href="https://wa.me/18096050699"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-fe-outline fe-cta-block__btn"
                                >
                                    <i className="fab fa-whatsapp mr-2"></i>Hablar con un asesor
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Footer */}
            <footer className="fe-footer">
                <div className="container">
                    <div className="row">
                        {/* Brand */}
                        <div className="col-12 col-lg-4 mb-4 mb-lg-0">
                            <a href="/" className="d-inline-block mb-3">
                                <img
                                    src="/assets/custom/images/logo-coralan-white.png"
                                    alt="Coralan Multiservice"
                                    className="fe-footer__logo"
                                />
                            </a>
                            <p className="fe-footer__brand-text">
                                Soluciones digitales especializadas en facturación electrónica
                                para empresas dominicanas. Cumplimiento total con la DGII.
                            </p>
                            <p className="fe-footer__rnc">RNC: 1-32-03635-2</p>
                        </div>

                        {/* Contact */}
                        <div className="col-12 col-sm-6 col-lg-4 mb-4 mb-sm-0">
                            <h4 className="fe-footer__section-title">Contáctenos</h4>
                            <div className="fe-footer__contact-item">
                                <i className="fas fa-map-marker-alt fe-footer__contact-icon"></i>
                                <span>
                                    C/ San Juan Bautista de la Salle #17, Mirador Norte, Santo Domingo, D.N.</span>
                            </div>
                            <div className="fe-footer__contact-item">
                                <i className="fab fa-whatsapp fe-footer__contact-icon"></i>
                                <span>+1 (809) 605-0699</span>
                            </div>
                            <div className="fe-footer__contact-item">
                                <i className="fas fa-phone-alt fe-footer__contact-icon"></i>
                                <span>+1 (809) 334-0405</span>
                            </div>
                            <div className="fe-footer__contact-item">
                                <i className="fas fa-envelope fe-footer__contact-icon"></i>
                                <span>info@coralanmultiservice.com</span>
                            </div>
                        </div>

                        {/* Links */}
                        <div className="col-12 col-sm-6 col-lg-4">
                            <h4 className="fe-footer__section-title">Navegación</h4>
                            <ul className="fe-footer__links">
                                <li>
                                    <a href="#fe-features">Beneficios</a>
                                </li>
                                <li>
                                    <a href="#fe-pricing">Planes</a>
                                </li>
                                <li>
                                    <a href="#fe-faq">Preguntas Frecuentes</a>
                                </li>
                                <li>
                                    <a href="/">Visitar sitio principal</a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <hr className="fe-footer__divider" />

                    <div className="row">
                        <div className="col-12 text-center">
                            <p className="fe-footer__copyright">
                                &copy; {new Date().getFullYear()} Coralan Multiservice. Todos los
                                derechos reservados. &mdash; Facturación Electrónica para
                                República Dominicana.
                            </p>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
};

export default FEFooter;
